import React from 'react';
import PropTypes from 'prop-types';
import theme from '../../../styles/theme';

const Spacer = ({ children, align, size, ...props }) => {
  const spacerStyle = {
    ...props.style,
    display: align === 'vertical' ? 'block' : 'inline-block',
    verticalAlign: align === 'horizontal' ? 'middle' : undefined,
  };

  const nodes = React.Children.toArray(children)
    .filter((element) => React.isValidElement(element))
    .map((element, index, elements) => {
      return React.cloneElement(element, {
        ...element.props,
        style: {
          ...element.props.style,
          marginRight:
            align === 'horizontal' && index !== elements.length - 1
              ? size
              : undefined,
          marginBottom:
            align === 'vertical' && index !== elements.length - 1
              ? size
              : undefined,
        },
      });
    });

  return (
    <div {...props} style={spacerStyle}>
      {nodes}
    </div>
  );
};

Spacer.propTypes = {
  children: PropTypes.node.isRequired,
  align: PropTypes.oneOf(['horizontal', 'vertical']),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
};

Spacer.defaultProps = {
  align: 'horizontal',
  size: theme.spacing.xs,
  style: {},
};

export default Spacer;
